var _rect, _pattern, _rect2, _rect3, _rect4, _text, _text2, _text3, _text4, _text5, _text6, _text7, _rect5, _text8, _text9, _text10, _text11, _text12, _text13, _rect6, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _rect7, _text24, _text25, _rect8, _text26, _text27, _text28, _text29, _text30, _rect9, _text31, _text32, _text33, _text34, _text35, _rect10, _text36, _text37, _text38, _text39, _text40, _rect11, _circle, _text41, _text42, _rect12, _rect13, _text43, _text44, _text45, _rect14, _text46, _text47, _text48, _text49, _rect15, _text50, _text51, _text52, _text53, _rect16, _text54, _text55, _text56, _text57, _rect17, _rect18, _text58, _text59, _text60, _text61, _text62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemapAiWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 675",
    width: 1200,
    height: 675,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#050505"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111111"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111827"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#bg4)"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60 0 L 0 0 0 60",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    opacity: 0.15
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 62,
    fill: "#050505",
    opacity: 0.98
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 61,
    width: 1200,
    height: 1,
    fill: "#1f1f1f"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 38,
    fill: "#ffffff",
    fontSize: 20,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "REMAP")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 38,
    fill: "#4b5563",
    fontSize: 20,
    fontFamily: "sans-serif"
  }, ".ai")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 37,
    fill: "#9ca3af",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "AI Consultant")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 37,
    fill: "#9ca3af",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "AI Projects")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 37,
    fill: "#9ca3af",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "AI Specialist")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 37,
    fill: "#9ca3af",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "About Us")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 37,
    fill: "#9ca3af",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "Blog")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 17,
    width: 140,
    height: 32,
    rx: 6,
    fill: "#ffffff"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 1110,
    y: 37,
    textAnchor: "middle",
    fill: "#000000",
    fontSize: 13,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Book a Call")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 128,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif",
    letterSpacing: 3
  }, "AI CONSULTANCY  \xB7  REMOTE &amp; GLOBAL")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 180,
    fill: "#ffffff",
    fontSize: 38,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Clarity out of the chaos.")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 230,
    fill: "#9ca3af",
    fontSize: 24,
    fontFamily: "sans-serif"
  }, "AI that works for your business.")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 268,
    fill: "#6b7280",
    fontSize: 14,
    fontFamily: "sans-serif"
  }, "We help businesses cut through the noise, find the right AI")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 288,
    fill: "#6b7280",
    fontSize: 14,
    fontFamily: "sans-serif"
  }, "opportunities, and build the things that actually move the dial.")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 308,
    width: 200,
    height: 44,
    rx: 8,
    fill: "#ffffff"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 334,
    textAnchor: "middle",
    fill: "#000000",
    fontSize: 14,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Book Discovery Call")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 334,
    fill: "#6b7280",
    fontSize: 14,
    fontFamily: "sans-serif"
  }, "See how it works \u2193")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 400,
    fill: "#ffffff",
    fontSize: 28,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "8+")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 420,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Years in AI delivery")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 400,
    fill: "#ffffff",
    fontSize: 28,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "100+")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 420,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Businesses advised")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 400,
    fill: "#ffffff",
    fontSize: 28,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Fixed")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 420,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Price per project")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 465,
    y: 400,
    fill: "#ffffff",
    fontSize: 28,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "2+ yrs")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 465,
    y: 420,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "EO Global Workshop Host")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 75,
    width: 490,
    height: 375,
    rx: 16,
    fill: "#0d0d0d",
    stroke: "#1f2937",
    strokeWidth: 1
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 118,
    fill: "#9ca3af",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "Three services. One clear path.")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 143,
    fill: "#ffffff",
    fontSize: 18,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "How We Work")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 162,
    width: 430,
    height: 70,
    rx: 10,
    fill: "#111111",
    stroke: "#1f2937",
    strokeWidth: 1
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 730,
    y: 188,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "01")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 188,
    fill: "#ffffff",
    fontSize: 15,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "AI Consultant")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 207,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Identify highest-impact AI opportunities.")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 222,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "ROI calculated before you spend a cent.")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 1090,
    y: 200,
    fill: "#4b5563",
    fontSize: 18,
    fontFamily: "sans-serif"
  }, "\u2192")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 244,
    width: 430,
    height: 70,
    rx: 10,
    fill: "#111111",
    stroke: "#ffffff",
    strokeWidth: 1
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 730,
    y: 270,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "02")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 270,
    fill: "#ffffff",
    fontSize: 15,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "AI Projects")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 289,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Scoped, priced, delivered. Fixed price.")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 304,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "No surprises. Support after launch.")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 1090,
    y: 282,
    fill: "#4b5563",
    fontSize: 18,
    fontFamily: "sans-serif"
  }, "\u2192")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 326,
    width: 430,
    height: 70,
    rx: 10,
    fill: "#111111",
    stroke: "#1f2937",
    strokeWidth: 1
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 730,
    y: 352,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "03")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 352,
    fill: "#ffffff",
    fontSize: 15,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "AI Specialist")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 371,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Vetted specialist embedded in your team.")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 386,
    fill: "#6b7280",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Full-time or fractional.")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 1090,
    y: 364,
    fill: "#4b5563",
    fontSize: 18,
    fontFamily: "sans-serif"
  }, "\u2192")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 408,
    width: 430,
    height: 40,
    rx: 10,
    fill: "#111111",
    stroke: "#ffffff",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 732,
    cy: 428,
    r: 10,
    fill: "#10b981"
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 432,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 10,
    fontWeight: "bold"
  }, "AI")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 752,
    y: 432,
    fill: "#9ca3af",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "AI Chatbot integrated \u2014 ask me anything about REMAP")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 452,
    width: 1200,
    height: 223,
    fill: "#050505"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 452,
    width: 1200,
    height: 1,
    fill: "#1f1f1f"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 492,
    fill: "#ffffff",
    fontSize: 20,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Why Most AI Fails")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 900,
    y: 492,
    fill: "#ef4444",
    fontSize: 24,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "80%")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 940,
    y: 492,
    fill: "#6b7280",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "of AI projects never pay back.")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 508,
    width: 320,
    height: 80,
    rx: 10,
    fill: "#0d0d0d",
    stroke: "#1f2937",
    strokeWidth: 1
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 532,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "01")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 532,
    fill: "#ffffff",
    fontSize: 13,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Wrong thing gets picked")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 552,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Chasing trends instead of")), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 568,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "fixing what costs money.")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 508,
    width: 320,
    height: 80,
    rx: 10,
    fill: "#0d0d0d",
    stroke: "#1f2937",
    strokeWidth: 1
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 532,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "02")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 532,
    fill: "#ffffff",
    fontSize: 13,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Build is rushed")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 552,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Over-engineered or handed to")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 568,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "the wrong person.")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 508,
    width: 380,
    height: 80,
    rx: 10,
    fill: "#0d0d0d",
    stroke: "#1f2937",
    strokeWidth: 1
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 532,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "03")), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 532,
    fill: "#ffffff",
    fontSize: 13,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "Nobody runs it after launch")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 552,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Without clear ownership it goes stale.")), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 568,
    fill: "#6b7280",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "ROI disappears.")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 607,
    width: 1200,
    height: 68,
    fill: "#000000"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 607,
    width: 1200,
    height: 1,
    fill: "#1f1f1f"
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 644,
    fill: "#4b5563",
    fontSize: 14,
    fontFamily: "sans-serif",
    fontWeight: "bold"
  }, "REMAP.ai")), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 644,
    fill: "#374151",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "Privacy Policy")), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 644,
    fill: "#374151",
    fontSize: 13,
    fontFamily: "sans-serif"
  }, "Terms")), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 644,
    fill: "#374151",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Built with WordPress \xB7 AI Chatbot \xB7 hello@remap.ai")), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    x: 1070,
    y: 644,
    fill: "#1f2937",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "\xA9 2025 remap.ai")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemapAiWebsite);
export default __webpack_public_path__ + "static/media/remap-ai-website.a91fbc0317a6f0a2a20690b623ae107f.svg";
export { ForwardRef as ReactComponent };